var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((5),function(item,i){return _c('div',{key:i},[_c('v-skeleton-loader',{attrs:{"type":"list-item-avatar-three-line"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }